import React from 'react';
import {
  Form,
  LabelInput,
} from '../../common/components/form';
import Button from '../../../ui/button/Button';

const SalesBoostForm = (props) => {
  const {
    enabled,
    onSubmit,
    onBlur,
    onInputChange,
    errors,
    touchedFields,
    isValid,
    boostActivated,
    scoreModifier,
  } = props;

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      <LabelInput
        inline
        disabled={boostActivated}
        label="Aseta myyntibuustille kerroin:"
        name="scoreModifier"
        type="text"
        value={scoreModifier}
        error={errors['scoreModifier'] && touchedFields.indexOf('scoreModifier') > -1}
        errorMessage={errors['scoreModifier']}
        onChange={onInputChange}
      />
      <Button disabled={!isValid || !enabled} type="submit">
        {boostActivated ? "Lopeta myyntibuusti" : "Käynnistä myyntibuusti"}
      </Button>
    </Form>
  );
};

export default SalesBoostForm;


// WEBPACK FOOTER //
// ./src/modules/campaign/components/SalesBoostForm.js